/**
 * Crowther · site-wide feature flags (Part 5.2 of the master build prompt).
 *
 * Each flag is a one-line revert. Do not add logic-branching gates here;
 * consumers import the flag they need and gate their own render path.
 *
 * Enterprise-side legacy flags live inside `Home.jsx` (SHOW_COLOUR_BAND,
 * SHOW_EDITORIAL_POLISH). Do not migrate them here yet.
 */

export const SHOW_GATEWAY = true;
export const SHOW_MACHINES_ARM = true;
export const SHOW_MACHINES_PROOF = false;
export const SHOW_MACHINES_ASSETS = false;
